import TargetMatcher from "../../../match/TargetMatcher"
import ExperimentActionResolver from "../match/ExperimentActionResolver"
import Bucketer from "../../../bucket/Bucketer"
import EvaluationFlow from "../../../flow/EvaluationFlow"
import {
  CompletedEvaluator,
  ContainerEvaluator,
  DefaultRuleEvaluator,
  DraftEvaluator,
  ExperimentFlow,
  ExperimentTargetEvaluator,
  IdentifierEvaluator,
  OverrideEvaluator,
  PausedEvaluator,
  TargetRuleEvaluator,
  TrafficAllocateEvaluator
} from "./ExperimentLocalFlowEvaluator"
import ExperimentTargetDeterminer from "../match/ExperimentTargetDeterminer"
import ExperimentTargetRuleDeterminer from "../match/ExperimentTargetRuleDeterminer"
import { ExperimentType } from "../../../../model/model"
import ExperimentOverrideResolver from "../match/ExperimentOverrideResolver"
import ExperimentContainerResolver from "../match/ExperimentContainerResolver"
import { ManualOverrideStorage } from "../match/ManualOverrideStorage"

export default class ExperimentLocalEvaluationFlowFactory {
  private readonly abTestFlow: ExperimentFlow
  private readonly featureFlagFlow: ExperimentFlow

  constructor(manualOverrideStorage: ManualOverrideStorage, bucketer: Bucketer, targetMatcher: TargetMatcher) {
    const actionResolver = new ExperimentActionResolver(bucketer)
    const overrideResolver = new ExperimentOverrideResolver(manualOverrideStorage, targetMatcher, actionResolver)
    const containerResolver = new ExperimentContainerResolver(bucketer)

    this.abTestFlow = EvaluationFlow.of(
      new OverrideEvaluator(overrideResolver),
      new IdentifierEvaluator(),
      new ContainerEvaluator(containerResolver),
      new ExperimentTargetEvaluator(new ExperimentTargetDeterminer(targetMatcher)),
      new DraftEvaluator(),
      new PausedEvaluator(),
      new CompletedEvaluator(),
      new TrafficAllocateEvaluator(actionResolver)
    )

    this.featureFlagFlow = EvaluationFlow.of(
      new DraftEvaluator(),
      new PausedEvaluator(),
      new CompletedEvaluator(),
      new OverrideEvaluator(overrideResolver),
      new IdentifierEvaluator(),
      new TargetRuleEvaluator(new ExperimentTargetRuleDeterminer(targetMatcher), actionResolver),
      new DefaultRuleEvaluator(actionResolver)
    )
  }

  flow(experimentType: ExperimentType): ExperimentFlow {
    switch (experimentType) {
      case "AB_TEST":
        return this.abTestFlow
      case "FEATURE_FLAG":
        return this.featureFlagFlow
    }
  }
}
